// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"355": "code_activation-CodeActivationModal","58": "code_activation-PhoneVerification",}[chunkId] + "." + {"355": "c72f66636cbc6e24","58": "0365c0243da6079c",}[chunkId] + ".js"
}